import { useEffect, useState } from "react";
import { Sparkles } from "lucide-react";
import { api, formatApiErrorDetail } from "../lib/api";
import { Button } from "./ui/button";
import { toast } from "./ui/sonner";

export const MatchSuggestions = ({ sessionId, onCreateMatch }) => {
  const [suggestions, setSuggestions] = useState(null);

  const load = () => {
    api.get(`/sessions/${sessionId}/match-suggestions`).then(({ data }) => setSuggestions(data));
  };

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionId]);

  const accept = async (s) => {
    try {
      await onCreateMatch(s.booking_id_a, s.booking_id_b);
      load();
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    }
  };

  if (suggestions === null) return null;

  return (
    <div className="mb-8" data-testid="match-suggestions-panel">
      <h3 className="font-extrabold uppercase text-sm tracking-wide mb-3 flex items-center gap-2">
        <Sparkles className="w-4 h-4 text-stranger-orange" /> Suggested Pairs
      </h3>
      {suggestions.length === 0 ? (
        <p className="text-sm font-medium text-midnight-black/50" data-testid="no-match-suggestions">
          No compatible pairs to suggest right now — register more Strangers or match manually below.
        </p>
      ) : (
        <div className="space-y-2" data-testid="match-suggestions-list">
          {suggestions.map((s, idx) => (
            <div key={`${s.booking_id_a}-${s.booking_id_b}`} className="border-2 border-soft-gray rounded-xl p-4 flex items-center justify-between gap-4 flex-wrap" data-testid={`match-suggestion-${idx}`}>
              <div>
                <p className="font-extrabold text-sm uppercase">
                  {s.stranger_a_name} + {s.stranger_b_name}
                  <span className="ml-2 text-[10px] font-bold tracking-widest uppercase px-2 py-0.5 rounded-full bg-stranger-orange text-clean-white">{s.score}% match</span>
                </p>
                <ul className="text-xs font-medium text-midnight-black/60 mt-1 list-disc list-inside">
                  {s.reasons.map((r, i) => (
                    <li key={i}>{r}</li>
                  ))}
                </ul>
              </div>
              <Button data-testid={`accept-suggestion-${idx}`} onClick={() => accept(s)} className="bg-midnight-black hover:bg-midnight-black/80 text-clean-white font-bold rounded-full text-xs">
                CREATE THIS MATCH
              </Button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
